import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-form-error-view',
    templateUrl: './form-error-view.component.html',
    styleUrls: ['./form-error-view.component.scss'],
    standalone: false
})
export class FormErrorViewComponent implements OnInit {

  @Input() errors: string[] = []

  constructor(private readonly cdr: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.cdr.markForCheck()
    console.log('error', this.errors)
  }

  ngOnInit(): void {
  }

}
